module.exports = __webpack_public_path__ + "static/media/juntos.8c3d5979.png";